<template>
  <div
    class="input-field"
    :class="{'error': validationError}"
  >
    <label
      v-if="label"
      :class="required ? 'required' : ''"
    >
      {{ label }}
    </label>

    <div
      class="mb-9"
      style="width: fit-content;"
    >
      <label
        for="file"
        class="cursor-pointer block"
      >
        <span
          class="btn btn-outline cursor-pointer"
          :class="validationError ? 'btn-danger' : 'btn-secondary'"
        >
          Choose File
        </span>
      </label>
      <input
        v-if="!disabled"
        id="file"
        class="hidden"
        type="file"
        :accept="accept"
        @change="handleEmitFile"
      >

      <span
        v-if="validationError"
        class="validation-error-message absolute -bottom-5"
      >
        {{ validationError }}
      </span>
    </div>
  </div>
</template>

<script setup>

const emit = defineEmits(['fileUploaded']);

const props = defineProps({
  label: {
    type: String,
    default: 'Upload file',
  },
  required: {
    type: Boolean,
    default: false,
  },
  validationError: {
    type: [Boolean, String],
    default: null,
  },
  accept: {
    type: String,
    default: 'image/jpeg,image/png',
  },
  disabled: Boolean,
});

const handleEmitFile = (e) => {
  if (!props.disabled) {
    emit('fileUploaded', e);
  }
};

</script>
